export const MENU_SVG_FINISH_PATH =
	'M-192.36-271.44C-479.11,1115.92,231.39,1747.62,2041.88,1611.87c85,9.11,6.86-1504.33-105.1-1504.33S1734.07,16.76,1734.07-95.2h0C1734.07-207.16-184.54-367.47-192.36-271.44Z';
